import React from 'react';
import { motion } from 'framer-motion';
import { Trash2, Plus, Minus } from 'lucide-react';

const CartItem = ({ item, index, updateQuantity, removeFromCart }) => (
  <motion.div
    key={`${item.id}-${item.selectedSize}`}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: index * 0.1 }}
    className="flex items-center space-x-6 p-6 rounded-2xl border border-border bg-background/50"
    data-testid={`cart-item-${item.id}`}
  >
    <div className="w-24 h-24 rounded-xl overflow-hidden flex-shrink-0">
      <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
    </div>
    <div className="flex-1">
      <h3 className="text-xl font-semibold text-foreground mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>{item.name}</h3>
      <p className="text-sm text-muted-foreground mb-2">{item.selectedSize}</p>
      <p className="text-lg font-semibold text-primary">${item.itemPrice}</p>
    </div>
    <div className="flex items-center space-x-4">
      <div className="flex items-center space-x-2 border border-border rounded-lg">
        <button onClick={() => updateQuantity(item.id, item.selectedSize, item.quantity - 1)} className="p-2 hover:bg-muted transition-colors rounded-l-lg" data-testid={`decrease-quantity-${item.id}`}>
          <Minus className="w-4 h-4" />
        </button>
        <span className="px-4 font-semibold" data-testid={`quantity-${item.id}`}>{item.quantity}</span>
        <button onClick={() => updateQuantity(item.id, item.selectedSize, item.quantity + 1)} className="p-2 hover:bg-muted transition-colors rounded-r-lg" data-testid={`increase-quantity-${item.id}`}>
          <Plus className="w-4 h-4" />
        </button>
      </div>
      <button onClick={() => removeFromCart(item.id, item.selectedSize)} className="p-2 hover:bg-red-50 hover:text-red-600 transition-colors rounded-lg" data-testid={`remove-item-${item.id}`}>
        <Trash2 className="w-5 h-5" />
      </button>
    </div>
  </motion.div>
);

export default CartItem;
